<template>
  <div class="report-page">
    <!-- 顶部标题和筛选区域（固定） -->
    <div class="top-header">
      <!-- 报表筛选 -->
      <div class="report-filter">
        <!-- 电脑端使用 Element UI 表单 -->
        <el-form v-if="isDesktop" :inline="true" :model="filterForm" class="filter-form">
          <el-form-item label="时间范围" label-width="80px">
            <el-date-picker
              v-model="filterForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="{ shortcuts: [{ text: '最近7天', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(end.getTime() - 3600 * 1000 * 24 * 7); picker.$emit('pick', [start, end]); } }, { text: '最近30天', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(end.getTime() - 3600 * 1000 * 24 * 30); picker.$emit('pick', [start, end]); } }] }"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </el-form-item>
        </el-form>
        
        <!-- 手机端使用 Vant 表单 -->
        <div v-else class="mobile-filter-form">
          <div class="form-item">
            <label class="form-label">时间范围</label>
            <div class="date-picker-wrapper">
              <div 
                class="date-picker-input" 
                @click="showDatePicker = !showDatePicker"
              >
                {{ formatDateRange }}
                <i class="el-icon-arrow-down"></i>
              </div>
              <!-- Vant 日期范围选择器 -->
              <van-popup
                v-model="showDatePicker"
                position="bottom"
                round
                :style="{ height: '80%' }"
              >
                <van-datetime-picker
                  v-model="currentDateRange"
                  type="daterange"
                  title="选择日期范围"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onDateConfirm"
                  @cancel="showDatePicker = false"
                />
              </van-popup>
            </div>
          </div>
          <div class="button-group">
            <van-button type="primary" block @click="handleFilter">查询</van-button>
            <van-button block @click="resetFilter" style="margin-top: 10px;">重置</van-button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 内容区域（可滚动） -->
    <div class="content-container">
      <!-- 报表图表 -->
      <div class="report-charts">
        <!-- 折线图 -->
        <div class="chart-container">
          <h3>销售趋势图</h3>
          <div ref="lineChart" class="chart" id="lineChart"></div>
        </div>
        
        <!-- 饼图 -->
        <div class="chart-container">
          <h3>销售分类占比</h3>
          <div ref="pieChart" class="chart" id="pieChart"></div>
        </div>
        
        <!-- 柱状图 -->
        <div class="chart-container">
          <h3>月度销售对比</h3>
          <div ref="barChart" class="chart" id="barChart"></div>
        </div>
        
        <!-- 电脑端多图表布局 -->
        <div v-if="isDesktop" class="chart-row">
          <!-- 雷达图 -->
          <div class="chart-container radar-chart">
            <h3>产品性能雷达图</h3>
            <div ref="radarChart" class="chart" id="radarChart"></div>
          </div>
          
          <!-- 散点图 -->
          <div class="chart-container scatter-chart">
            <h3>价格与销量关系</h3>
            <div ref="scatterChart" class="chart" id="scatterChart"></div>
          </div>
        </div>
        
        <!-- 手机端单图表布局 -->
        <div v-else>
          <!-- 雷达图 -->
          <div class="chart-container">
            <h3>产品性能雷达图</h3>
            <div ref="radarChart" class="chart" id="radarChart"></div>
          </div>
          
          <!-- 散点图 -->
          <div class="chart-container">
            <h3>价格与销量关系</h3>
            <div ref="scatterChart" class="chart" id="scatterChart"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ReportPage',
  data() {
    return {
      isDesktop: true,
      filterForm: {
        dateRange: []
      },
      // 手机端日期选择器
      showDatePicker: false,
      currentDateRange: [new Date(), new Date()],
      minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
      maxDate: new Date(),
      // 图表实例
      lineChart: null,
      pieChart: null,
      barChart: null,
      radarChart: null,
      scatterChart: null,
      // 模拟数据
      salesData: {
        dates: ['1月', '2月', '3月', '4月', '5月', '6月'],
        sales: [120, 200, 150, 80, 70, 110],
        categories: [
          { name: '电子产品', value: 400 },
          { name: '家居用品', value: 300 },
          { name: '办公用品', value: 200 },
          { name: '其他', value: 100 }
        ],
        monthlyData: {
          categories: ['1月', '2月', '3月', '4月', '5月', '6月'],
          2023: [100, 150, 130, 180, 200, 220],
          2024: [120, 200, 150, 80, 70, 110]
        },
        performanceData: [
          { 
            name: '产品A',
            value: [80, 90, 70, 85, 95, 88]
          },
          { 
            name: '产品B',
            value: [90, 85, 80, 90, 88, 92]
          }
        ],
        scatterData: [
          [100, 200], [200, 350], [300, 450], [400, 500], [500, 600],
          [600, 700], [700, 800], [800, 900], [900, 1000], [1000, 1100]
        ]
      }
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.initCharts()
  },
  computed: {
    // 格式化日期范围显示
    formatDateRange() {
      if (!this.filterForm.dateRange || this.filterForm.dateRange.length === 0) {
        return '选择日期范围'
      }
      return `${this.filterForm.dateRange[0]} 至 ${this.filterForm.dateRange[1]}`
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
    this.destroyCharts()
  },
  methods: {
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
      // 图表容器大小变化后重新渲染图表
      this.$nextTick(() => {
        this.resizeCharts()
      })
    },
    initCharts() {
      this.initLineChart()
      this.initPieChart()
      this.initBarChart()
      this.initRadarChart()
      this.initScatterChart()
    },
    destroyCharts() {
      if (this.lineChart) {
        this.lineChart.dispose()
      }
      if (this.pieChart) {
        this.pieChart.dispose()
      }
      if (this.barChart) {
        this.barChart.dispose()
      }
      if (this.radarChart) {
        this.radarChart.dispose()
      }
      if (this.scatterChart) {
        this.scatterChart.dispose()
      }
    },
    resizeCharts() {
      if (this.lineChart) {
        this.lineChart.resize()
      }
      if (this.pieChart) {
        this.pieChart.resize()
      }
      if (this.barChart) {
        this.barChart.resize()
      }
      if (this.radarChart) {
        this.radarChart.resize()
      }
      if (this.scatterChart) {
        this.scatterChart.resize()
      }
    },
    initLineChart() {
      this.lineChart = echarts.init(this.$refs.lineChart)
      // 从CSS变量获取颜色
      const rootStyles = getComputedStyle(document.documentElement)
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['销售额']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.salesData.dates
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '销售额',
            type: 'line',
            stack: 'Total',
            data: this.salesData.sales,
            smooth: true,
            itemStyle: {
              color: rootStyles.getPropertyValue('--primary')
            }
          }
        ]
      }
      this.lineChart.setOption(option)
    },
    initPieChart() {
      this.pieChart = echarts.init(this.$refs.pieChart)
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '销售分类',
            type: 'pie',
            radius: '50%',
            data: this.salesData.categories,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.pieChart.setOption(option)
    },
    initBarChart() {
      this.barChart = echarts.init(this.$refs.barChart)
      // 从CSS变量获取颜色
      const rootStyles = getComputedStyle(document.documentElement)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['2023年', '2024年']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.salesData.monthlyData.categories
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '2023年',
            type: 'bar',
            data: this.salesData.monthlyData['2023'],
            itemStyle: {
              color: rootStyles.getPropertyValue('--success')
            }
          },
          {
            name: '2024年',
            type: 'bar',
            data: this.salesData.monthlyData['2024'],
            itemStyle: {
              color: rootStyles.getPropertyValue('--danger')
            }
          }
        ]
      }
      this.barChart.setOption(option)
    },
    initRadarChart() {
      this.radarChart = echarts.init(this.$refs.radarChart)
      const option = {
        tooltip: {},
        legend: {
          data: this.salesData.performanceData.map(item => item.name)
        },
        radar: {
          indicator: [
            { name: '性价比', max: 100 },
            { name: '质量', max: 100 },
            { name: '外观', max: 100 },
            { name: '功能', max: 100 },
            { name: '易用性', max: 100 },
            { name: '售后', max: 100 }
          ]
        },
        series: [
          {
            type: 'radar',
            data: this.salesData.performanceData.map(item => ({
              value: item.value,
              name: item.name
            }))
          }
        ]
      }
      this.radarChart.setOption(option)
    },
    initScatterChart() {
      this.scatterChart = echarts.init(this.$refs.scatterChart)
      // 从CSS变量获取颜色
      const rootStyles = getComputedStyle(document.documentElement)
      const option = {
        tooltip: {
          trigger: 'item'
        },
        xAxis: {
          name: '价格',
          type: 'value'
        },
        yAxis: {
          name: '销量',
          type: 'value'
        },
        series: [
          {
            name: '价格销量关系',
            type: 'scatter',
            data: this.salesData.scatterData,
            itemStyle: {
              color: rootStyles.getPropertyValue('--accent')
            },
            symbolSize: 10
          }
        ]
      }
      this.scatterChart.setOption(option)
    },
    handleFilter() {
      this.$message('查询数据')
      // 实际项目中这里会调用API获取数据
    },
    resetFilter() {
      this.filterForm.dateRange = []
      this.$message('重置筛选条件')
    },
    // 处理 Vant 日期选择器确认事件
    onDateConfirm() {
      const [start, end] = this.currentDateRange
      // 格式化日期为 yyyy-MM-dd 格式
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      this.filterForm.dateRange = [formatDate(start), formatDate(end)]
      this.showDatePicker = false
    }
  }
}
</script>

<style scoped>
/* 使用全局样式中定义的 CSS 变量 */
.report-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 顶部标题和筛选区域（固定） */
.top-header {
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 0;
}

.top-header h2 {
  margin-bottom: 20px;
  color: var(--text);
}

.report-filter {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
}

.report-filter .filter-form {
  display: flex;
  align-items: center;
}

/* 手机端筛选表单样式 */
.report-filter .mobile-filter-form {
  width: 100%;
}

.report-filter .mobile-filter-form .form-item {
  margin-bottom: 15px;
}

.report-filter .mobile-filter-form .form-label {
  display: block;
  margin-bottom: 8px;
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text-200);
}

.report-filter .mobile-filter-form .date-picker-wrapper {
  position: relative;
}

.report-filter .mobile-filter-form .date-picker-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  padding: 0 15px;
  background-color: var(--bg-200);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-md);
  color: var(--text-200);
  cursor: pointer;
  transition: border-color 0.2s;
}

.report-filter .mobile-filter-form .date-picker-input:hover {
  border-color: var(--primary);
}

.report-filter .mobile-filter-form .date-picker-input i {
  color: var(--text-200);
  font-size: var(--font-size-sm);
}

.report-filter .mobile-filter-form .button-group {
  margin-top: 20px;
}

/* 内容区域（可滚动） */
.content-container {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
}

.report-charts {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.chart-container {
  background-color: var(--bg-200);
  padding: 20px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  transition: var(--transition);
}

.chart-container:hover {
  box-shadow: var(--shadow-lg);
}

.chart-container h3 {
  margin-bottom: 20px;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
}

.chart {
  width: 100%;
  height: 400px;
}

.chart-row {
  display: flex;
  gap: 30px;
}

.chart-row .radar-chart,
.chart-row .scatter-chart {
  flex: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-header {
    padding-bottom: 15px;
  }
  
  .top-header h2 {
    margin-bottom: 15px;
  }
  
  .content-container {
    padding: 15px 0;
  }
  
  .chart-row {
    flex-direction: column;
  }
  
  .chart {
    height: 300px;
  }
  
  .report-filter .filter-form {
    display: none;
  }
  
  .report-filter {
    padding: 15px;
  }
}
</style>